@if(componentModel){
    <a class="rounded-lg min-w-72 bg-card text-center md:text-left shadow overflow-hidden block {{mainClass}}"
       [attr.href]="componentModel?.link?.value || null"
       [ngClass]="{
        'hover:bg-card-hover': componentModel?.link?.value
    }">
        <div class="p-4 sm:flex text-normal">
            <div class="mb-4 shrink-0 sm:mb-0 sm:mr-4 m-auto  max-w-32">
                <img loading="lazy"  [src]="componentModel?.image?.value" class="soviet-effect  aspect-square object-cover object-center" [alt]="componentModel.title.value">
            </div>
            <div>
                <h4 class="text-lg font-bold">{{componentModel?.title?.value}}</h4>
                <p class="mt-1">
                    {{componentModel?.description?.value}}
                </p>
            </div>
        </div>
    </a>
}

